import { useQuery } from 'react-query';
import {
  Filter,
  getClientsList,
  ClientListResponse,
  getMoneylenders,
  MoneylenderResponse,
  getRelatedMoneylenders,
  RelatedMoneylenderResponse,
} from '../api/clients';

export function useQueryClients(
  isLabeled: boolean,
  commercialRelation: string | undefined,
  page: number,
  take: number,
  filters: Filter[]
) {
  return useQuery(
    ['client-list', isLabeled, commercialRelation, page, take, filters],
    (): Promise<ClientListResponse> => {
      const skipEntriesIndex = page * take;
      return getClientsList(isLabeled, commercialRelation, skipEntriesIndex, take, filters);
    }
  );
}

export function useRelatedMoneylenders() {
  return useQuery(['clients-relatedMoneylenders'], () => fetchRelatedMoneylenders());
}

async function fetchRelatedMoneylenders(): Promise<RelatedMoneylenderResponse[]> {
  return getRelatedMoneylenders();
}

export function useMoneylenders() {
  return useQuery(
    ['clients-moneylenders'],
    (): Promise<MoneylenderResponse[]> => getMoneylenders()
  );
}
